import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from 'react-toastify';
import { Modal, Popover, Tabs } from 'antd';
import { useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { useSelector } from "react-redux";
import { API } from "../../config/constants";
import Pagination from "../../utils/Pagination";
import { formatDateToDMY, formatTime12Hour, formatEventType } from "../../utils/tools";
import ContentLoader from "../../utils/ContentLoader";
import { useState } from "react";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import ImagePreviewModal from "../../utils/ImagePreviewModal";

const { confirm } = Modal;

const ReadingPlanTable = ({
    readingplan,
    roles,
    page,
    setPage,
    totalPages,
    totalEntries,
    sort,
    order,
    setOrder,
    setSort,
    search,
    setSearch,
    fetchReadingPlan,
    onView
}) => {
    const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    console.log("reading plan====>", readingplan);

    const headerConfig = [
        //  { key: "id", label: "ID", sortable: false },
        { key: "user_name", label: "User Name", sortable: false },
        { key: "start_date", label: "Started At", sortable: false },
        { key: "normalOrShuffeled", label: "Plan", sortable: false },
        { key: "plan_type", label: "Plan Type", sortable: false },
        { key: "pending_days", label: "Pending Days ", sortable: false },
        { key: "completed_days", label: "Completed Days", sortable: false },
        // { key: "remaining_days", label: "Remaining Days", sortable: false },
        // { key: "status", label: "Status", sortable: false },
        { key: "action", label: "Action", sortable: false }
    ];

    if (loading) return <ContentLoader />;

    // const getTotalRemainingDays = (item) => {
    //     const startDate = new Date(item.start_date);
    //     const endDate = new Date(item.end_date);

    //     // Calculate dynamic remaining days until end_date
    //     const calculated = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    //     const dynamicDays = calculated > 0 ? calculated : 0;

    //     // Use DB remaining_days only if > 0
    //     const dbRemaining = Number(item.remaining_days) > 0 ? Number(item.remaining_days) : 0;

    //     // Subtract completed days (ensure number)
    //     const completed = Number(item.completed_days) || 0;

    //     // Total pending days
    //     const total = dbRemaining + dynamicDays - completed;

    //     // Debug logs
    //     console.log("==== Pending Days Debug ====");
    //     console.log("User:", item.user_name || item.user?.name);
    //     console.log("DB remaining_days:", item.remaining_days, "=> used:", dbRemaining);
    //     console.log("Calculated dynamic days:", calculated, "=> used:", dynamicDays);
    //     console.log("Completed days:", item.completed_days, "=> used:", completed);
    //     console.log("Total pending days:", total);
    //     console.log("============================");

    //     // Only return if > 0
    //     return total > 0 ? total : "-";
    // };

    return (
        <div className="card basic-data-table text-sm overflow-x-auto">
            <div className="card-header responsive-header d-flex justify-content-end align-items-center global-header">
                <div className="d-flex align-items-center gap-3">
                    {/* Refresh Icon */}
                    <Icon
                        icon="mdi:refresh"
                        width="26"
                        height="26"
                        className="ms-2 text-lg d-none d-md-inline-flex refresh-icon "
                        onClick={fetchReadingPlan}
                    />

                    <div className="search-container" style={{ gap: "10px" }}>
                        <SearchBy
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                            }}
                        />
                        {viewPermissions.includes("readingplan.create") && (
                            <button
                                className="btn btn-primary-600 global-add-btn"
                                type="button"
                                onClick={() => navigate("/events-form")}
                            >
                                <Icon
                                    icon="fa6-regular:square-plus"
                                    className="icon text-lg line-height-1"
                                />
                                Add
                            </button>
                        )}
                    </div>
                </div>
            </div>
            <div className="card-body card-body-modify">
                <div className="w-full overflow-x-auto">
                    <table className="table bordered-table mb-0 text-sm w-full min-w-max" id="dataTable">
                        <thead>
                            <tr>
                                {TableSortHeaders(headerConfig, sort, order, setSort, setOrder, setPage)}
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(readingplan) && readingplan.length > 0 ? (
                                readingplan.map((item) => (
                                    <tr key={item.id}>
                                        {/* Event Title */}
                                        {/* <td>{item.id}</td> */}

                                        {/* Church Name */}
                                        <td className="d-flex align-items-center gap-2">
                                            <ImagePreviewModal
                                                src={item.user?.avatar ? `${item.user?.avatar}` : "/assets/images/fall-back-church.webp"}
                                                fallback="/assets/images/logo-profile.png"
                                                alt={item.church_name}
                                                thumbWidth={50}
                                                thumbHeight={50}
                                            />
                                            <span>{item.user?.name}</span>
                                        </td>



                                        {/* Start Date & Time */}
                                        <td>
                                            {item.start_date
                                                ? `${formatDateToDMY(item.start_date)} ${formatTime12Hour(item.start_date)
                                                }`
                                                : "-"}
                                        </td>

                                        {/*Plan Type */}
                                        <td>
                                            {(item.normalOrShuffeled || "-")}
                                        </td>


                                        {/*Plan Type */}
                                        <td>
                                            {(item.plan_type || "-")}
                                        </td>

                                        {/* Remaining Days*/}
                                        <td>
                                            {item.remaining_days > 0 ? item.remaining_days : 0}
                                        </td>

                                        {/* completed Days*/}
                                        <td>
                                            {(item.completed_days || "-")}
                                        </td>

                                        {/* <td>
                                            {getTotalRemainingDays(item)}
                                        </td> */}


                                        {/* LAST READING Date & Time */}
                                        {/* <td>
                                            {item.readed
                                                ? `${formatDateToDMY(item.readed)} ${formatTime12Hour(item.readed)
                                                }`
                                                : "-"}
                                        </td> */}



                                        {/* Recurring Type */}
                                        {/* <td>
                                            {item.is_recurring
                                                ? (
                                                    (!item.recurring_type || item.recurring_type === "none") && !item.recurring_pattern
                                                        ? "-"
                                                        : `${item.recurring_type || "-"} / ${item.recurring_pattern || "-"}`
                                                )
                                                : "-"}
                                        </td> */}

                                        {/* City */}
                                        {/* <td>{item.church?.place}</td> */}

                                        {/* Status */}
                                        {/* <td>
                                            <span
                                                className={`px-24 py-4 rounded-pill fw-medium text-sm ${item.status === "new"
                                                    ? "bg-warning-focus text-warning-600"
                                                    : item.status === "accepted"
                                                        ? "bg-success-focus text-success-main"
                                                        : item.status === "rejected"
                                                            ? "bg-danger-focus text-danger-main"
                                                            : ""
                                                    }`}
                                            >
                                                {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                            </span>
                                        </td> */}

                                        {/* Actions */}
                                        <td>
                                            <div className="d-flex align-items-center justify-content-between">

                                                {/* Left Side - View Icon */}
                                                {viewPermissions.includes("event.view") && (
                                                    <button
                                                        className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                                        onClick={() => onView(item)}
                                                    >
                                                        <Icon icon="iconamoon:eye-light" />
                                                    </button>
                                                )}

                                                {/* Right Side - Three Dots */}
                                                {/* <Popover
                                                    trigger="click"
                                                    placement="bottomRight"
                                                    overlayClassName="action-popover"
                                                    content={
                                                        <div className="action-list">
                                                            {viewPermissions.includes("readingplan.edit") && (
                                                                <button
                                                                    onClick={() => navigate(`/events-form/${item.id}`)}
                                                                    className="action-item text-success-main"
                                                                >
                                                                    <Icon icon="lucide:edit" />
                                                                    <span>Edit</span>
                                                                </button>
                                                            )}

                                                            {viewPermissions.includes("readingplan.delete") && (
                                                                <button
                                                                    className="action-item text-danger-main"
                                                                    onClick={() => onDelete(item.id)}
                                                                >
                                                                    <Icon icon="mingcute:delete-2-line" />
                                                                    <span>Delete</span>
                                                                </button>
                                                            )}
                                                        </div>
                                                    }
                                                >
                                                     {viewPermissions.includes("readingplan.edit") && (
                                                    <button
                                                        type="button"
                                                        className="w-32-px h-32-px bg-neutral-300 rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                                                    >
                                                        <Icon icon="mdi:dots-vertical" />
                                                    </button>
                                                    )}
                                                </Popover> */}

                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7} className="text-center">
                                        No Event found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                />
            </div>
        </div>
    );
};

export default ReadingPlanTable;